module.exports = __webpack_public_path__ + "img/rank-list.9b69d4c7.svg";